const state = () => ({
  isLoading: false,
  isEmpty: false,
});

// getters
const getters = {};

// actions
const actions = {
  loadingOn({ commit }) {
    commit('loadingToggleOn');
  },
  loadingOff({ commit }) {
    commit('loadingToggleOff');
  },
};

// mutations
const mutations = {
  loadingToggleOn(state) {
    state.isLoading = true;
  },
  loadingToggleOff(state) {
    state.isLoading = false;
  },
  emptyToggleOn(state) {
    state.isEmpty = true;
  },
  emptyToggleOff(state) {
    state.isEmpty = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
